import { render } from "./ExpertStatisticsQueueComparator.vue?vue&type=template&id=303301c8"
import script from "./ExpertStatisticsQueueComparator.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsQueueComparator.vue?vue&type=script&lang=js"
script.render = render

export default script